import { render, staticRenderFns } from "./Label.vue?vue&type=template&id=a2b001d6&"
import script from "./Label.vue?vue&type=script&setup=true&lang=js&"
export * from "./Label.vue?vue&type=script&setup=true&lang=js&"
import style0 from "./Label.vue?vue&type=style&index=0&id=a2b001d6&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports